<template>
  <section>
    <div :class="$style.resourceHeading">
      <HeadingExtraSmall
        data-test-id="DevicesList__devicesHeading"
        :hasMargin="false"
      >
        {{ $options.deviceConfig.label }}
      </HeadingExtraSmall>
      <HeadingExtraSmall
        v-if="showResourceCount"
        :class="$style.additionalItems"
        data-test-id="DevicesList__devicesAdditionalItems"
        :hasMargin="false"
        weight="light"
      >
        {{ getResourceCountText }}
      </HeadingExtraSmall>
    </div>
    <LoadingIcon
      v-if="isLoading"
      :scale="1.75"
    />
    <ResourceError
      v-else-if="hasError"
      data-test-id="DevicesList__devicesError"
    />
    <ParagraphBody
      v-else
      data-test-id="DevicesList__devicesList"
    >
      {{ getDevicesList }}
      <ButtonLink
        v-if="showDevicesLink"
        :class="$style.linkText"
        data-test-id="DevicesList__deviceAssignLink"
        :text="$options.deviceConfig.linkText"
        @click="navigateToTab($options.deviceConfig.label)"
      />
    </ParagraphBody>
  </section>
</template>

<script>
import {
  ButtonLink,
  HeadingExtraSmall,
  LoadingIcon,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import ItemType from 'client/util/Constants/ItemType';
import ResourceError from './ResourceError.vue';

const { DeviceItemType } = ItemType;
const deviceItem = new DeviceItemType();
const systemUserModel = 'SystemUserModel';

export default {
  name: 'DevicesList',

  components: {
    ButtonLink,
    HeadingExtraSmall,
    LoadingIcon,
    ParagraphBody,
    ResourceError,
  },

  data: () => ({
    devicesList: [],
    hasError: false,
    isLoading: true,
    totalCount: 0,
  }),

  deviceConfig: {
    label: deviceItem.titlePlural,
    linkText: `Assign a ${deviceItem.label}`,
    zeroStateText: `No ${deviceItem.labelPlural} have been directly assigned to this user.`,
  },

  computed: {
    getDevicesList() {
      return this.devicesList.length
        ? this.devicesList.join(', ')
        : this.$options.deviceConfig.zeroStateText;
    },

    getResourceCountText() {
      return `Showing first 100 of ${this.totalCount} items`;
    },

    showDevicesLink() {
      return this.devicesList.length === 0;
    },

    showResourceCount() {
      return this.totalCount > 100;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(systemUserModel, ['fetchDeviceAssociations']),

    async getDevices() {
      const { data, errorOccurred, totalCountOfDevices } = await this.fetchDeviceAssociations();

      data.results.forEach((association) => {
        this.devicesList.push(association.displayName);
      });
      this.devicesList.sort();
      this.hasError = errorOccurred;
      this.totalCount = totalCountOfDevices;
    },

    async handleMounted() {
      await this.getDevices();
      this.isLoading = false;
    },

    navigateToTab(tabLabel) {
      this.$emit('changeTab', tabLabel);
    },
  },
};
</script>

<style scoped module>
.resourceHeading {
  display: flex;
}

.additionalItems {
  padding-left: var(--jc-spacer-small);
}

.linkText.linkText {
  text-transform: none;
}
</style>
